import { useEffect, useState } from 'react';
import { isMobile as isMobileHelper } from '@zola-helpers/client/dist/es/util/responsive';

export const setupMobileCheck = (setIsMobile: (isMobile: boolean) => void): (() => void) => {
  if (typeof window === 'undefined') {
    return () => undefined;
  }

  const handler = () => {
    setIsMobile(isMobileHelper());
  };

  // Check mobile status on first render
  handler();

  window.addEventListener('resize', handler);

  return () => {
    window.removeEventListener('resize', handler);
  };
};

export const useMobileCheck = (): boolean => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const teardown = setupMobileCheck(setIsMobile);
    return teardown;
  }, []);

  return isMobile;
};
